import { useState } from "react";
import { useAddSubscription } from "../hooks/useNewsletter";

interface AddSubscriptionModalProps {
  onClose: () => void;
}

const AddSubscriptionModal = ({ onClose }: AddSubscriptionModalProps) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const { mutate: addSubscription, isPending } = useAddSubscription();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (!email.trim()) {
      setError("El email es requerido");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("El formato del email no es válido");
      return;
    }

    addSubscription(email, {
      onSuccess: () => {
        onClose();
      },
      onError: (err: unknown) => {
        if (err instanceof Error) {
          setError(err.message || "Error al agregar suscriptor");
        } else {
          setError("Error al agregar suscriptor");
        }
      },
    });
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
      onClick={handleBackdropClick}
    >
      <div className="w-full max-w-md rounded-lg border border-slate-800 bg-surface p-6 shadow-xl">
        <h2 className="mb-4 text-xl font-semibold text-primary">Agregar suscriptor</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="mb-2 block text-sm font-medium text-slate-300">
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError("");
              }}
              placeholder="ejemplo@email.com"
              disabled={isPending}
              className="w-full rounded-md border border-slate-700 bg-background px-3 py-2 text-slate-200 outline-none transition focus:border-primary disabled:opacity-50"
            />
            {error ? <p className="mt-1 text-sm text-red-400">{error}</p> : null}
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={isPending}
              className="rounded-md border border-slate-700 bg-background px-4 py-2 text-sm font-semibold text-slate-300 transition hover:border-primary disabled:opacity-50"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={isPending}
              className="rounded-md bg-primary px-4 py-2 text-sm font-semibold text-white transition hover:bg-primaryAccent disabled:opacity-50"
            >
              {isPending ? "Agregando..." : "Agregar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSubscriptionModal;
